// extracted by mini-css-extract-plugin
export default {"marked":"YesNoQuestion_marked__jwhJc","label":"YesNoQuestion_label__b3It-","radioGroup":"YesNoQuestion_radioGroup__tAWza"};